var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2255_492)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 44,
    height: 44,
    rx: 12,
    fill: "#B31017",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.85 30C23.85 25.4989 27.4989 21.85 32 21.85C32.8909 21.85 33.7468 21.9927 34.5471 22.2557C34.9931 22.4023 35.4734 22.1596 35.62 21.7136C35.7666 21.2676 35.5239 20.7873 35.0779 20.6407C34.1085 20.3221 33.0735 20.15 32 20.15C26.56 20.15 22.15 24.56 22.15 30C22.15 35.44 26.56 39.85 32 39.85C37.44 39.85 41.85 35.44 41.85 30C41.85 29.5306 41.4695 29.15 41 29.15C40.5306 29.15 40.15 29.5306 40.15 30C40.15 34.5011 36.5011 38.15 32 38.15C27.4989 38.15 23.85 34.5011 23.85 30ZM39.6024 25.5998C39.9336 25.2671 39.9324 24.7289 39.5998 24.3977C39.2671 24.0665 38.7289 24.0676 38.3977 24.4003L32.0496 30.776L29.621 28.1781C29.3004 27.8351 28.7625 27.817 28.4195 28.1376C28.0766 28.4582 28.0585 28.9961 28.3791 29.339L31.4094 32.5805C31.567 32.749 31.7863 32.8463 32.0169 32.8499C32.2476 32.8536 32.4699 32.7633 32.6327 32.5998L39.6024 25.5998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2255_492",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.552941 0 0 0 0 0.709804 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2255_492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2255_492",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.9b501415fb5ac1ef53d72e32f2b03a3b.svg";
export { ForwardRef as ReactComponent };